import React from 'react';
import { Box, Button, Typography } from '@mui/material';

export interface EmptyProps {
  description?: string;
  buttonLabel?: string;
  onClick?: () => void;
}

export const Empty = ({ description = 'No table data', buttonLabel = 'Click here', onClick }: EmptyProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 3,
        minHeight: 300,
      }}
    >
      <Typography color="textSecondary">{description}</Typography>

      {onClick && (
        <Box sx={{ marginTop: 3 }}>
          <Button variant="contained" color="secondary" onClick={onClick}>
            {buttonLabel}
          </Button>
        </Box>
      )}
    </Box>
  );
};
